import React, { Children, Component } from "react"
import Loading from "../../components/Loading/Loading"
import TabScreen from "../../components/TabScreen"
import { getUserFlashcardsCached } from "../../services/flashcards/flashcards-rest-interface"
import FlashcardsModal from "./FlashcardsModal"
import FlashcardsDecks from "./FlashcardsDecks"
import { IFlashcard } from "./types"
import FlashcardsGenericInfo from "./FlashcardsGenericInfo"
import FlashcardsDeck from "./FlashcardsDeck"
import "./index.css"
import FlashcardsDecksWithSubcategories from "./FlashcardsDecksWithSubcategories"

interface Props {

}

interface State {
    flashcards: IFlashcard[]
    modalVisible: boolean
    category: string
    status: string
    subcategory?: string
}

export default class FlashcardsScene extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            flashcards: [],
            modalVisible: false,
            category: "English",
            status: "new",
        }
    }

    async componentDidMount() {
        let flashcards = await getUserFlashcardsCached()        
        this.setState({flashcards})
    }

    handleModalClose = () => {
        this.setState({modalVisible: false})
    }

    onShowDeck = (category, status: string, subcategory?: string) => {
        this.setState({modalVisible: true, category, status, subcategory})
    }

    render() {
        let {flashcards, modalVisible, category, status, subcategory} = this.state

        if (flashcards.length === 0) {
            return <Loading/>
        }

        let screens = [
            {name: "English", screen: <FlashcardsScreen category="English" flashcards={flashcards} onShowDeck={this.onShowDeck}/>},
            {name: "Math",    screen: <FlashcardsScreen category="Math"    flashcards={flashcards} onShowDeck={this.onShowDeck}/>},
            {name: "Science", displayName: "ACT Science", screen: <FlashcardsScreen category="Science" flashcards={flashcards} onShowDeck={this.onShowDeck}/>},
            {name: "SATVocab", displayName: "SAT Vocab", screen: <FlashcardsScreen category="SATVocab" flashcards={flashcards} onShowDeck={this.onShowDeck}/>},
        ]

        return (
            <TabScreen title="Flashcards" screens={screens}>
                <FlashcardsModal show={modalVisible} onClose={this.handleModalClose} dismissible={true}>
                    <FlashcardsDeck
                        flashcards={flashcards}
                        category={category}
                        flashcardStatus={status}
                        subcategory={subcategory}
                        onClose={this.handleModalClose} />
                </FlashcardsModal>
            </TabScreen>
        )
    }
}

//--- Helpers ---
interface IFlashcardsScreen {
    category: string // English | Math | Science | SATVocab, etc.
    flashcards: IFlashcard[],
    onShowDeck: (category: string, status: string) => void
}

function FlashcardsScreen(props: IFlashcardsScreen) {
    let {category, flashcards, onShowDeck} = props
    let selectedFlashcards = flashcards.filter(f => f.category === category)

    return (
        <div className="flashcards-screen">
            <FlashcardsGenericInfo />
            { category === "SATVocab" ?
                <FlashcardsDecksWithSubcategories category={category} flashcards={selectedFlashcards} onShowDeck={onShowDeck}/>
                :
                <FlashcardsDecks category={category} flashcards={selectedFlashcards} onShowDeck={onShowDeck}/>
            }
        </div>
    )
}
